import React, { useState, useCallback, memo } from "react";
import { Text, Col, PageView, Table, Button } from "components/YeyComponents";
import { colors } from "utils/StyleUtils";
import api from "services/api";
import {
  isYesNoAllLOV,
  techSheetTypeLOV,
  paginationLimit,
  queryParamsConstructor,
} from "utils/Utils";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { Menu, MenuItem } from "@material-ui/core";
import { downloadCustomerRelations } from "redux/actions/report";
import { useDispatch } from "react-redux";

const FichaTecnica = () => {
  const defaultFilterValues = [
    { name: "name", operator: "contains", type: "string" },
    { name: "type", operator: "contains", type: "string" },
    { name: "inUse", operator: "eq", type: "string" },
    { name: "isDefault", operator: "eq", type: "string" },
  ];

  const [newFilterValue, setNewFilterValue] = useState(defaultFilterValues);
  const [limit, setLimit] = useState(paginationLimit);
  const history = useHistory();

  const dispatch = useDispatch();

  const loadData = (props = {}) => {
    const {
      skip = 0,
      sortInfo = "",
      groupBy = "",
      filterValue = newFilterValue,
    } = props;

    const queryParams = queryParamsConstructor({
      limit,
      skip,
      sortInfo,
      groupBy,
      filterValue,
    });

    return api.get("tech_sheets", { params: queryParams }).then((response) => {
      const totalCount = response?.data?.total;
      return {
        data: response?.data?.techSheets?.map((c) => {
          return c;
        }),
        count: totalCount * 1,
      };
    });
  };

  const dataSource = useCallback(loadData, [newFilterValue, limit]);

  const techSheetTypeRender = useCallback(({ value }) => {
    return (
      techSheetTypeLOV.filter((item) => {
        return item.id === value;
      })[0]?.label || "Não identificado"
    );
  }, []);
  const techSheetActiveRender = useCallback(({ value }) => {
    if (value) return "Sim";
    else return "Não";
  }, []);

  const ActionComponent = memo(({ data }) => {
    const [isMenuVisible, setIsMenuVisible] = useState(null);

    const handleClick = (event) => {
      setIsMenuVisible(event?.currentTarget);
    };

    const handleClose = () => {
      setIsMenuVisible(false);
    };

    const editTechSheet = () => {
      setIsMenuVisible(false);
      history.push(`/menu/cadastro/ficha_tecnica/${data?.id}`);
    };

    let defaultMenuItem =
      data.isDefault == false ? (
        <MenuItem onClick={() => {}}>Definir como Padrão</MenuItem>
      ) : null;

    return (
      <>
        <div id="action" onClick={handleClick}>
          <BsThreeDotsVertical size={20} />
        </div>
        <Menu
          id="simple-menu"
          anchorEl={isMenuVisible}
          keepMounted
          open={Boolean(isMenuVisible)}
          onClose={handleClose}
        >
          <MenuItem onClick={editTechSheet}>Editar Ficha</MenuItem>
          {defaultMenuItem}
        </Menu>
      </>
    );
  });

  return (
    <PageView>
      <Col align={{ horizontal: "flex-start" }} flex={1} height="99%">
        <Text type="title" color={colors.darkGrey}>
          Fichas Técnicas
        </Text>
        {/* eslint-disable-next-line react/style-prop-object */}
        <Button
          style="submit"
          viewStyle={{ padding: { bottom: "1em" }, align: "flex-start" }}
          onClickFunction={() =>
            history.push("/menu/cadastro/ficha_tecnica/novo")
          }
        >
          Adicionar ficha técnica
        </Button>
        <Table
          title="Fichas Técnicas cadastradas"
          data={dataSource}
          limit={limit}
          columns={[
            {
              name: "id",
              header: "#",
              type: "number",
              defaultWidth: 5,
              defaultVisible: false,
              defaultFlex: 0.5,
            },
            {
              name: "name",
              header: "Nome da Ficha",
              type: "string",
              defaultWidth: 50,
              defaultVisible: false,
              defaultFlex: 3,
            },
            {
              name: "type",
              header: "Tipo de Ficha",
              type: "string",
              defaultWidth: 20,
              defaultVisible: false,
              defaultFlex: 1,
              render: techSheetTypeRender,
            },
            {
              name: "isDefault",
              defaultFlex: 1,
              header: "Modelo Padrão",
              filterType: "select",
              filterEditorProps: {
                placeholder: "Todos",
                dataSource: isYesNoAllLOV,
              },
              render: techSheetActiveRender,
            },
            {
              name: "action",
              header: "",
              width: 20,
              defaultFlex: 0.25,
              render: ({ data }) => <ActionComponent data={data} />,
              sortable: false,
            },
          ]}
          defaultFilterValues={defaultFilterValues}
          sortable
          pagination={true}
          onFilterValueChange={setNewFilterValue}
          onLimitChange={setLimit}
        />
      </Col>
    </PageView>
  );
};

export default FichaTecnica;
